
export const caseStudies = {
  caseStudiesHero: {
    subtitle: 'CASE STUDIES',
    title: '导入案例',
  },
  empowerment: {
    title: 'EMPOWERMENT CODE ACADEMY',
    subtitle: '将温柔转化为不屈的力量',
    concept: '理念',
    conceptText: '许多女性虽然渴望\"改变\"却止步不前的原因，并非意志薄弱。而是源于从幼年时期无意识中被植入的\"认知结构\"。',
    description1: 'EMPOWERMENT CODE ACADEMY是一所教育机构，从脑科学和行为心理学的视角，解析并重新设计女性特有的思维模式，而非通过精神论或一时的激昂。',
    description2: '我们提出独特的框架，在不损害女性本有的\"慈爱\"的前提下，将其升华为推动社会的\"柔韧力量\"。从被情感波涛吞没的主角，转变为自如操控自己人生\"结构（CODE）\"的设计者。从日本走向世界，带来真正自律与和谐的新教育标准，从这里开始。',
    button: '咨询此项目详情',
  },
  quantum: {
    title: 'QUANTUM MEDICINE ACADEMY',
    titleKana: '',
    subtitle: '科学理解身心结构，重新定义生命表现',
    description: '量子医学学院整合神经科学、量子理论、行动心理学，系统化人类\"思考·情感·身体\"的相互作用。这是一所实践教育机构，不仅仅是知识的习得，而是通过利用大脑可塑性的科学训练，旨在从根本上重构生存策略（行为模式）。',
    professionalPath: {
      label: 'PROFESSIONAL PATH',
      title: '量子医学治疗师学科',
      description: '培养在临床现场立即发挥作用的\"评估能力\"和\"干预设计能力\"。以身心相关和自律神经调节理论为基础，构建医疗·对人支援的下一代标准。',
    },
    selfOptimizationPath: {
      label: 'SELF-OPTIMIZATION PATH',
      title: '健康学科',
      description: '迈向自我调节能力の极致。通过呼吸、姿势、情绪管理，习得科学再现可持续高表现状态的技术。',
    },
    button: '咨询此项目详情',
  },
  corporate: {
    title: 'CORPORATE & SOCIAL SOLUTIONS',
    subtitle: '为组织与社会带来可复制の变革',
    description: '从企业培训到下一代教育支援，再到全国規模の研讨会。将DREAM CODE理論作为现实社会の变革加以证明。',
    solutions: {
      training: {
        subtitle: 'Corporate Training',
        title: '企业培训',
        description: '提供领导力开发、生产力提升的结构设计项目。',
      },
      nextGen: {
        subtitle: 'Next Generation',
        title: '下一代教育支援',
        description: '在教育現場普及\"结构性思维\"，培养志向高远の年轻一代。',
      },
      seminars: {
        subtitle: 'National Seminars',
        title: '全国研讨会',
        description: '通过在日本各地举办工作坊，将DREAM CODE回馈社会。',
      },
    },
    bottomMessage: '正因为日本有如此多の実績，在国际会议上获奖也是必然の。理論与実践の融合，创造真正的变革。',
  },
};
